import Vue from 'vue'
Vue.directive("focusClass", {
	inserted: function(el) {},
	bind: (el, binding) => {
		el.addEventListener("focus", () => {
			let className = el.className.split(" ");
			if (className.indexOf(binding.value) == -1) {
				className.push(binding.value);
				el.className = className.join(" ");
			}
		}, true);
		el.addEventListener("blur", () => {
			let className = el.className.split(" ");
			let index = className.indexOf(binding.value);
			if (index > -1) {
				className.splice(index, 1)
				el.className = className.join(" ");
			}
		}, true);
	}
});
